import Vue from "vue";
import { RequestService } from "@/common/api.service";
import {
  REQUEST_FORM_GET,
  REQUEST_FORM_SAVE_DRAFT,
  REQUEST_FORM_UPDATE,
  CLEAR_SAVE_MESSAGE,
  COMPANY_SAVE,
  CLEAR_DRAFT_FORM,
  REQUEST_LABEL_GET,
  GET_CURRENT_REQUESTS,
  GET_COMPLETED_REQUESTS,
  REQUEST_FORM_GET_DETAIL,
  REQUEST_TEAM_GET,
  GET_DECLARATIONS_REQUESTS,
  GET_CURRENT_REQUESTS_DECLARATIONS,
  GET_COMPLETED_REQUESTS_DECLARATIONS,
  REQUEST_DECLARATION_FORM_GET_DETAIL,
  DECLARATION_FORM_UPDATE,
  ADD_REQUEST_COMMENT,
  ADD_DECLARATION_COMMENT,
  DELETE_FILE,
  PRELABEL_FORM_UPDATE,
  DECLARATION_FORM_GET,
  DECLARATION_FORM_SAVE,
  GET_INVESTORS_REQUESTS,
  CHECK_INVESTORS_REQUESTS
} from "./actions.type";
import {
  SET_REQUEST_FORM,
  RESET_STATE,
  SET_SHARED_DATA,
  SET_ERROR,
  PURGE_ERROR,
  SET_SAVE_MESSAGE,
  PURGE_SAVE_MESSAGE,
  PURGE_DRAFT_FORM,
  SET_START_LEAVE_DATE,
  SET_START_BOURSE_DATE,
  SET_END_BOURSE_DATE,
  SET_DECLARATION_FORM
} from "./mutations.type";

const initialState = {
  requestForm: {},
  declarationForm: {},
  errors: null,
  saveMessage: null,
  startLeaveDate: null,
  startBourseDate: null,
  endBourseDate: null,
  sharedData: null
};

export const state = { ...initialState };

export const actions = {
  /* Get Team Request */
  async [REQUEST_TEAM_GET](context, params) {
    const { data } = await RequestService.requestTeamGet(
      params.label,
      params.type_id,
      params.team
    );
    context.commit(SET_REQUEST_FORM, data.data);
    return data;
  },
  /* Get Form Request */
  async [REQUEST_FORM_GET](context, params) {
    const { data } = await RequestService.requestFormGet(
      params.label,
      params.type_id
    );
    context.commit(SET_REQUEST_FORM, data.data);
    return data;
  },
  async [DECLARATION_FORM_GET](context, params) {
    const { data } = await RequestService.declarationFormGet(
      params.type,
      params.formName,
      params.hashId
    );
    context.commit(SET_DECLARATION_FORM, data.data);
    return data;
  },
  /* Get Request By Details */
  async [REQUEST_FORM_GET_DETAIL](context, params) {
    const { data } = await RequestService.requestFormGetDetail(
      params.label,
      params.type_id,
      params.request_id
    );
    context.commit(SET_REQUEST_FORM, data.data);
    return data;
  },
  /* Get Current Requests*/
  async [GET_CURRENT_REQUESTS](context, params) {
    const { data } = await RequestService.getCurrentRequests(
      params.id,
      params.code_label
    );
    context.commit(SET_REQUEST_FORM, data.data);
    return data;
  },
  /* Get Completed Requests */
  async [GET_COMPLETED_REQUESTS](context, params) {
    const { data } = await RequestService.getCompletedRequests(
      params.id,
      params.code_label
    );
    context.commit(SET_REQUEST_FORM, data.data);
    return data;
  },
  async [REQUEST_LABEL_GET](context, params) {
    const { data } = await RequestService.requestLabelGet(params.type_id);
    context.commit(SET_REQUEST_FORM, data.data);
    return data;
  },
  [REQUEST_FORM_SAVE_DRAFT](context, form) {
    if (form.label) {
      var label = form.label;
    } else {
      var label = null;
    }
    return new Promise((resolve, reject) => {
      RequestService.requestFormSaveDraft(
        label,
        form.id,
        form.type_id,
        form.member_id,
        form.responses
      )
        .then(({ data }) => {
          context.commit(SET_REQUEST_FORM, data.data);
          if (data.meta.errors) context.commit(SET_ERROR, data.meta.errors);
          else context.commit(PURGE_ERROR);
          context.commit(SET_SAVE_MESSAGE, true);
          resolve(data);
        })
        .catch(({ response }) => {
          if (response != undefined) {
            context.commit(SET_REQUEST_FORM, response.data.data);
            context.commit(SET_ERROR, response.data.meta.errors);
          }
          reject(response);
        });
    });
  },
  [DECLARATION_FORM_SAVE](context, payload) {
    return new Promise((resolve, reject) => {
      RequestService.declarationFormSave(payload.form, payload.formName)
        .then(({ data }) => {
          context.commit(SET_DECLARATION_FORM, data.data);
          if (data.meta.errors) context.commit(SET_ERROR, data.meta.errors);
          else context.commit(PURGE_ERROR);
          context.commit(SET_SAVE_MESSAGE, true);
          resolve(data);
        })
        .catch(({ response }) => {
          if (response != undefined) {
            context.commit(SET_DECLARATION_FORM, response.data.data);
            context.commit(SET_ERROR, response.data.meta.errors);
          }
          reject(response);
        });
    });
  },
  /* Update Form Request */
  [REQUEST_FORM_UPDATE](context, form) {
    if (form.label) {
      var label = form.label;
    } else {
      var label = null;
    }
    return new Promise((resolve, reject) => {
      RequestService.requestFormUpdate(
        label,
        form.type_id,
        form.request_id,
        form.responses
      )
        .then(({ data }) => {
          context.commit(SET_REQUEST_FORM, data.data);
          if (data.meta.errors) context.commit(SET_ERROR, data.meta.errors);
          else context.commit(PURGE_ERROR);
          context.commit(SET_SAVE_MESSAGE, true);
          resolve(data);
        })
        .catch(({ response }) => {
          if (response != undefined) {
            context.commit(SET_REQUEST_FORM, response.data.data);
            context.commit(SET_ERROR, response.data.meta.errors);
          }
          reject(response);
        });
    });
  },
  [PRELABEL_FORM_UPDATE](context, form) {
    return new Promise((resolve, reject) => {
      RequestService.prelabelFormUpdate(
        form
      )
        .then(({ data }) => {
          context.commit(SET_REQUEST_FORM, data.data);
          if (data.meta.errors) context.commit(SET_ERROR, data.meta.errors);
          else context.commit(PURGE_ERROR);
          resolve(data);
        })
        .catch(({ response }) => {
          if (response != undefined) {
            context.commit(SET_REQUEST_FORM, response.data.data);
            context.commit(SET_ERROR, response.data.meta.errors);
          }
          reject(response);
        });
    });
  },
  async [COMPANY_SAVE](context, playload) {
    const { data } = await RequestService.companySave(
      playload.form,
      playload.app_id
    );
    return data;
  },
  [CLEAR_SAVE_MESSAGE](context) {
    context.commit(PURGE_SAVE_MESSAGE);
  },
  [CLEAR_DRAFT_FORM](context) {
    context.commit(PURGE_DRAFT_FORM);
  },
  /* Add comment request */
  async [ADD_REQUEST_COMMENT](context, payload) {
    const { data } = await RequestService.commentRequest(
      payload.label,
      payload.type_id,
      payload.request_id,
      payload.comment,
      payload.documentId
    );
    //context.commit(SET_REQUEST_FORM, data.data);
    return data;
  },
  /* Get List Requests Declarations */
  async [GET_DECLARATIONS_REQUESTS](context, payload) {
    const { data } = await RequestService.getListRequestsDeclarations(payload);
    return data;
  },
  /* Get Investors List Declarations */
  async [GET_INVESTORS_REQUESTS](context, payload) {
    const { data } = await RequestService.getInvestorsListDeclarations(payload);
    return data;
  },
  /* Check Investors Declarations */
  async [CHECK_INVESTORS_REQUESTS](context, app_id) {
    const { data } = await RequestService.checkInvestorsDeclarations(app_id);
    return data;
  },
  /* Get Current Requests Declaration */
  async [GET_CURRENT_REQUESTS_DECLARATIONS](context, app_id) {
    const { data } = await RequestService.getCurrentRequestsDeclarations(
      app_id
    );
    return data.data.CurrentRequestsDeclarations;
  },
  /* Get Declaration Request By Details */
  async [REQUEST_DECLARATION_FORM_GET_DETAIL](context, params) {
    const { data } = await RequestService.requestDeclarationFormGetDetail(
      params.appType,
      params.formName,
      params.hash_id
      
    );
    //context.commit(SET_REQUEST_FORM, data.data);
    return data;
  },
  /* Get Completed Requests Declaration */
  async [GET_COMPLETED_REQUESTS_DECLARATIONS](context, app_id) {
    const { data } = await RequestService.getCompletedRequestsDeclarations(
      app_id
    );
    return data.data.CompletedRequestsDeclarations;
  },
  /* Update Form Declaration */
  [DECLARATION_FORM_UPDATE](context, form) {
    return new Promise((resolve, reject) => {
      RequestService.requestDeclarationFormUpdate(
        form.appType,
        form.formName,
        form.declarationId,
        form.responses
      )
        .then(({ data }) => {
          context.commit(SET_REQUEST_FORM, data.data);
          if (data.meta.errors) context.commit(SET_ERROR, data.meta.errors);
          else context.commit(PURGE_ERROR);
          context.commit(SET_SAVE_MESSAGE, true);
          resolve(data);
        })
        .catch(({ response }) => {
          if (response != undefined) {
            context.commit(SET_REQUEST_FORM, response.data.data);
            context.commit(SET_ERROR, response.data.meta.errors);
          }
          reject(response);
        });
    });
  },
  /* Add comment declaration */
  async [ADD_DECLARATION_COMMENT](context, payload) {
    const { data } = await RequestService.commentDeclaration(
      payload.type,
      payload.form_code,
      payload.request_id,
      payload.comment,
      payload.documentId
    );
    return data;
  },
  /* Delete file from `forms_responses` and from storage */
  async [DELETE_FILE](context, payload) {
    await RequestService.deleteFile(payload);
  }
};

export const mutations = {
  [SET_SHARED_DATA](state, data) {
    state.sharedData = data;
  },
  [RESET_STATE]() {
    for (let f in state) {
      Vue.set(state, f, initialState[f]);
    }
  },
  [SET_DECLARATION_FORM](state, data) {
    state.declarationForm = data.form;
  },
  [SET_REQUEST_FORM](state, data) {
    state.requestForm = data.form;
  },
  [PURGE_DRAFT_FORM](state) {
    state.requestForm = { questions: [] };
  },
  [SET_SAVE_MESSAGE](state, data) {
    state.saveMessage = data;
  },
  [PURGE_SAVE_MESSAGE](state) {
    state.saveMessage = null;
  },
  [SET_ERROR](state, error) {
    state.errors = error;
  },
  [PURGE_ERROR](state) {
    state.errors = null;
  },
  [SET_START_LEAVE_DATE](state, data) {
    state.startLeaveDate = data;
  },
  [SET_START_BOURSE_DATE](state, data) {
    state.startBourseDate = data;
  },
  [SET_END_BOURSE_DATE](state, data) {
    state.endBourseDate = data;
  }
};

const getters = {
  getSharedData(state) {
    return state.sharedData;
  },
  declarationForm(state) {
    return state.declarationForm;
  },
  requestForm(state) {
    return state.requestForm;
  },
  startLeaveDate(state) {
    return state.startLeaveDate;
  },
  startBourseDate(state) {
    return state.startBourseDate;
  },
  endBourseDate(state) {
    return state.endBourseDate;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
